import React from "react";

function MenuAboutCard() {
  return (
    <div className="menuAboutCard">
      <h1>Unkai Radio</h1>
      <p>This radio is a cloned version of radio.garden app</p>
    </div>
  );
}

export default MenuAboutCard;
